import React, { useEffect, useState } from 'react';
import { Col, Input, Row } from 'reactstrap';
import CompanyAutocomplete from './CompanyAutocomplete';
import { useSelector } from 'react-redux';
import ModelAutoComplete from './ModelAutoComplete';
import { update } from 'lodash';

const ROLE_LIST = [
  { name: 'Admin', value: 'admin' },
  { name: 'Enterprise Admin', value: 'enterpriseAdmin' },
];

const REQUEST_STATUS = ['Pending', 'Approved', 'Rejected'];

const RequestEdit = ({ selectedRequest, updatedUserData }) => {
  const {
    email,
    name,
    companyName,
    company,
    role,
    status,
    phoneNumber
  } = selectedRequest;

  const companies = useSelector(state => state.AppState.companies);
  const user = useSelector(state => state.AppState.user);
  const [updatedUser, setUpdatedUser] = useState({
    status,
    name,
    email,
    role,
    company: companyName,
    phoneNumber,
    selectedCompanyName: ""
  });

  useEffect(() => {
    setUpdatedUser({
      ...updatedUser,
      company: company?._id,
      selectedCompanyName: company?.name
    });
  }, []);

  const onCompanySelect = company => {
    setUpdatedUser({ ...updatedUser, company: company?.suggestion?._id, selectedCompanyName: company?.suggestion?.name });
  };

  const onRoleChange = role => {
    setUpdatedUser({ ...updatedUser, role: role?.suggestion?.value });
  };

  const onStatusChange = status => {
    setUpdatedUser({ ...updatedUser, status: status?.target?.value });
  };

  useEffect(() => {
    updatedUserData(updatedUser);
  }, [updatedUser, updatedUserData]);

  return (
    <>
      <Row>
        <Col>
          <p>User Submitted Company:</p>
        </Col>
        <Col>
          <p className='selected-company'>{companyName}</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>Company</p>
        </Col>
        <Col>
          <CompanyAutocomplete
            className="testing-filter"
            placeholder="Filter"
            companies={companies.docs || []}
            searchTerm={company?.name || ''}
            onChange={e => onCompanySelect(e)}
            isDisabled={user.role === 'admin'}
          />

        </Col>
      </Row>
      <Row>
        <Col>
          <p>Role</p>
        </Col>
        <Col>

          <ModelAutoComplete
            searchTerm={ROLE_LIST.name || ''}
            placeholder="Filter Role"
            models={ROLE_LIST}
            onChange={onRoleChange}
            className="mb-3"
          />

        </Col>
      </Row>
      <Row>
        <Col>
          <p>Request Status</p>
        </Col>
        <Col>
          <Input
            type="select"
            style={{ marginBottom: '1em' }}
            name="status"
            // value={value}
            onChange={e => onStatusChange(e)}
          >
            {REQUEST_STATUS.map(el => (
              <option key={el} value={el}>
                {el}
              </option>
            ))}
          </Input>

        </Col>
      </Row>
    </>
  );
}

export default RequestEdit;
